import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import {
    MdControlPoint,
    MdDelete,
    MdKeyboardDoubleArrowLeft,
    MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../../components/Images/icons/Export_Icon_01.png";
import NoRecordTable from '../../../../components/CommonComponents/NoRecordTable'
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import MessageBox from "../../../../components/CommonComponents/MessageBox";
import { IoClose } from "react-icons/io5";
import { IconDeleteFigma, IconEditFigma } from "../../../../Assets/MyIcons";
import AdminTooltip from "../../../../components/CommonComponents/AdminTooltip";

function ContentClassification(props) {
    const [loading, setLoading] = useState(true);
    const [reloading, setReLoading] = useState(false);
    const [getClassification, setClassification] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [itemToDelete, setItemToDelete] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [filter, setFilter] = useState("");
    const [modelClose, setModelClose] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false);

    const [validationMessageTitle, setValidationMessageTitle] = useState("");
    const [isValidationHiddenTitle, setIsValidationHiddenTitle] = useState(true);
    const [validationMessageDescription, setValidationMessageDescription] = useState("");
    const [isValidationHiddenDescription, setIsValidationHiddenDescription] = useState(true);

    const titleInputRef = useRef(null);
    const descriptionInputRef = useRef(null);

    const [editUser, setEditUser] = useState({
        id: "",
        title: "",
        description: "",
    });

    const access_token = localStorage.getItem("access_token");
    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
    };

    const fetchClassifications = async () => {
        try {
            setLoading(true)
            const response = await axios.get(
                `${process.env.REACT_APP_Baseurl}/admin/content-classification/index`,
                { headers: headers }
            );
            if (response?.data?.status === true) {
                setClassification(response?.data?.AllClassification || []);
                setFilteredData(response?.data?.AllClassification || []);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchClassifications();
    }, [withOutRefresh]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setEditUser((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "title") {
            if (value.trim() !== "") {
                setValidationMessageTitle("");
                setIsValidationHiddenTitle(true);
            }
        }
        if (name === "description") {
            if (value.trim() !== "") {
                setValidationMessageDescription("");
                setIsValidationHiddenDescription(true);
            }
        }
    };

    const handleModalClose = () => {
        setEditUser({ id: "", title: "", description: "" });
        setValidationMessageTitle("");
        setValidationMessageDescription("");
        setIsValidationHiddenTitle(true);
        setIsValidationHiddenDescription(true);
    };

    const inputCheck = async () => {
        let focusInputRef = null;
        let isValid = true;

        if (!editUser?.title || editUser.title.trim() === "") {
            setValidationMessageTitle("Title cannot be empty.");
            setIsValidationHiddenTitle(false);
            focusInputRef = titleInputRef;
            isValid = false;
        }

        if (!editUser?.description || editUser.description.trim() === "") {
            setValidationMessageDescription("Description cannot be empty.");
            setIsValidationHiddenDescription(false);
            if (!focusInputRef) focusInputRef = descriptionInputRef;
            isValid = false;
        }

        if (focusInputRef) {
            focusInputRef?.current?.focus();
        }

        if (isValid) {
            saveClassification();
        }
    };

    const saveClassification = async () => {
        const formData = {
            title: editUser?.title,
            description: editUser?.description,
        };

        try {
            let response;
            if (editUser.id) {
                response = await axios.post(
                    `${process.env.REACT_APP_Baseurl}/admin/content-classification/update/${editUser.id}`,
                    formData,
                    { headers: headers }
                );
            } else {
                response = await axios.post(
                    `${process.env.REACT_APP_Baseurl}/admin/content-classification/store`,
                    formData,
                    { headers: headers }
                );
            }

            if (response?.data?.status === true) {
                toast.success(response?.data?.message);
                const modalElement = document.getElementById('addClassification');
                if (modalElement) {
                    const modal = window.bootstrap.Modal.getInstance(modalElement);
                    if (modal) modal.hide();
                }
                handleModalClose();
                setWithOutRefresh(prev => !prev);
                if (props.isModal && props.onSuccess) {
                    props.onSuccess(editUser?.title);
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong!");
        }
    };

    const deleteOperation = async () => {
        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_Baseurl}/admin/content-classification/multi-delete`,
                {
                    headers: headers,
                    data: { id: [...itemToDelete] }
                }
            );
            if (response?.data?.status === true) {
                toast.success(response?.data?.message);
                setModelClose(false);
                setItemToDelete([]);
                setWithOutRefresh(prev => !prev);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Delete failed");
        }
    };

    const handleEdit = (row) => {
        setEditUser({
            id: row.id,
            title: row.title,
            description: row.description
        });
        // Trigger modal manually if needed or via data-bs-toggle
    };

    const handleFilterChange = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setFilter(searchTerm);
        const filteredResults = getClassification?.filter((item) =>
            ["title", "description", "upload_on"].some(
                (property) =>
                    typeof item[property] === "string" &&
                    item[property].toLowerCase().includes(searchTerm)
            )
        );
        setFilteredData(filteredResults);
    };

    const handleClear = () => {
        setFilter("");
        setFilteredData(getClassification);
    };

    const openModalSingleDelete = (id) => {
        setItemToDelete([id]);
        setModelClose(true);
    };

    const closeModal = () => {
        setModelClose(false);
        setItemToDelete([]);
        setSelectAll(false);
    };

    const reloadAction = async () => {
        setReLoading(true);
        await fetchClassifications();
        setReLoading(false);
    };

    const actionFormatter = (data, row) => {
        return (
            <div className="editdropdown">
                <span className="editdropdown-button">
                    <span>
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </span>
                </span>
                <div className="editdropdown-menu">
                    <div
                        onClick={() => handleEdit(row)}
                        data-bs-toggle="modal"
                        data-bs-target="#addClassification"
                        className="cursor-pointer d-flex align-items-center p-2"
                    >
                        <IconEditFigma styled={{ width: "24px", height: "24px" }} />
                        <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                    </div>

                    <div
                        onClick={() => openModalSingleDelete(row?.id)}
                        className="commonActionPadding cursor-pointer d-flex align-items-center p-2"
                    >
                        <IconDeleteFigma styled={{ width: "24px", height: "24px" }} />
                        <MessageBox text="Delete" classname='ms-2 theme-text-color'></MessageBox>
                    </div>
                </div>
            </div>
        );
    };

    const userFormatter = (data, row) => {
        return (
            <div className="d-flex flex-column align-items-start">
                <span className="fw-bold">{data}</span>
                <span className="dateText"> {row?.upload_on}</span>
            </div>
        );
    };

    const descriptionFormatter = (data) => {
        const displayStr = data?.length > 50 ? `${data.slice(0, 50)}...` : data;
        return <span>{displayStr}</span>;
    };

    const columns = [
        {
            dataField: "title",
            text: "Title",
            formatter: userFormatter,
        },
        {
            dataField: "description",
            text: "Description",
            formatter: descriptionFormatter,
        },
        {
            dataField: "ACTIONS",
            text: "Actions",
            formatter: actionFormatter,
            headerStyle: () => {
                return { width: '80px', textAlign: 'center' };
            },
            style: { textAlign: 'center' }
        },
    ];

    const selectRow = {
        mode: "checkbox",
        onSelect: (row, isSelect) => {
            if (isSelect) {
                setItemToDelete([...itemToDelete, row.id]);
            } else {
                setItemToDelete(itemToDelete.filter((id) => id !== row?.id));
            }
        },
        onSelectAll: (isSelect, rows) => {
            if (isSelect) {
                setItemToDelete(rows.map((r) => r.id));
            } else {
                setItemToDelete([]);
            }
        },
        selected: itemToDelete,
    };

    const pagination = paginationFactory({
        page: 1,
        sizePerPage: 10,
        nextPageText: "Next",
        prePageText: "Prev",
        firstPageText: <MdKeyboardDoubleArrowLeft />,
        lastPageText: <MdKeyboardDoubleArrowRight />,
        showTotal: true,
        alwaysShowAllBtns: true,
        sizePerPageList: [
            { text: "5", value: 5 },
            { text: "10", value: 10 },
            { text: "All", value: filteredData.length },
        ],
    });

    if (props.isModal) {
        return (
            <div className="p-3">
                <div>
                    <MessageLabel text="Title" className="mandatorySimple" />
                    <AdminCustomInput
                        type="text"
                        name="title"
                        value={editUser?.title}
                        onChange={handleInput}
                        placeHolder="Enter classification title"
                        ref={titleInputRef}
                        error={validationMessageTitle}
                    />
                </div>

                <div className="mt-2">
                    <MessageLabel text="Description" className="mandatorySimple" />
                    <textarea
                        name="description"
                        className={`form-control ${!isValidationHiddenDescription ? 'is-invalid' : ''}`}
                        value={editUser?.description}
                        onChange={handleInput}
                        placeholder="Enter description"
                        ref={descriptionInputRef}
                        rows="4"
                    ></textarea>
                    {!isValidationHiddenDescription && <div className="invalid-feedback d-block">{validationMessageDescription}</div>}
                </div>
                <div className="mt-4 text-end">
                    <button type="button" className="btn btn-primary" onClick={inputCheck}>
                        {editUser.id ? "Update" : "Save"}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* Delete Confirmation Modal */}
            <div
                className={`modal packageModel ${modelClose ? "show" : ""}`}
                tabIndex="-1"
                style={{ display: modelClose ? "block" : "none" }}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header theme-border-bottom-secondary">
                            <MessageBox text={"Confirm Deletion"} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                            <button type="button" className='bg-transparent theme-text-color' onClick={closeModal} ><IoClose style={{ width: "25px", height: "25px" }} /></button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete the selected item(s)?</p>
                        </div>
                        <div className="modal-footer gap-3 border-0">
                            <button type="button" className="bg-transparent theme-text-color px-2" onClick={closeModal}>Cancel</button>
                            <button type="button" className="btn warningColorBg theme-button-text-color px-3" onClick={deleteOperation}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Modal */}
            <div
                className="modal fade"
                id="addClassification"
                tabIndex="-1"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{editUser.id ? "Edit" : "Add"} Content Classification</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={handleModalClose}></button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <MessageLabel text="Title" className="mandatorySimple" />
                                <AdminCustomInput
                                    type="text"
                                    name="title"
                                    value={editUser?.title}
                                    onChange={handleInput}
                                    placeHolder="Enter classification title"
                                    ref={titleInputRef}
                                    error={validationMessageTitle}
                                />
                            </div>

                            <div className="mt-2">
                                <MessageLabel text="Description" className="mandatorySimple" />
                                <textarea
                                    name="description"
                                    className={`form-control ${!isValidationHiddenDescription ? 'is-invalid' : ''}`}
                                    value={editUser?.description}
                                    onChange={handleInput}
                                    placeholder="Enter description"
                                    ref={descriptionInputRef}
                                    rows="4"
                                ></textarea>
                                {!isValidationHiddenDescription && <div className="invalid-feedback d-block">{validationMessageDescription}</div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={inputCheck}>
                                {editUser.id ? "Update" : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section container-fluid pt-3">
                <div id="content-page" className="content-page">
                    <div className="row admin-section-title">
                        <div className="col-md-8">
                            <h4 className="admin-title mb-0 theme-text-color">
                                Content Classification
                                <span className="admin-sub-title theme-text-color ms-2 ">( {getClassification?.length} results found )</span>
                            </h4>
                        </div>
                        <div className="col-md-4 mt-3 mt-md-0" align="right">
                            {itemToDelete?.length > 0 && (
                                <button className="btn warningColorBg theme-button-text-color d-inline-flex fw-bold mb-3" onClick={() => setModelClose(true)}>
                                    <MdDelete className="me-1" /> Delete
                                </button>
                            )}
                            <button
                                type="button"
                                className="admin-title ms-3 rounded-2 d-inline-flex align-items-center button-bg-color theme-button-text-color py-2 px-3"
                                data-bs-toggle="modal"
                                data-bs-target="#addClassification"
                                onClick={() => setEditUser({ id: "", title: "", description: "" })}
                            >
                                <MdControlPoint className="me-2 " style={{ width: "22px", height: "22px" }} /> <MessageBox classname="admin-button-text " text={"Add New"} />
                            </button>
                        </div>
                    </div>

                    <div className="iq-card mt-3">
                        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                            <div className="filterContainer">
                                <input type="text" placeholder="Search" className="filter form-control" value={filter} onChange={handleFilterChange} />
                                {filter.length > 0 && <button type="button" className="closeBtn" onClick={handleClear}><i className="fa fa-times"></i></button>}
                            </div>
                            <div className="btn-group">
                                <button className="bg-transparent reloadButton theme-text-color p-2 border border-2 rounded-circle theme-border-color" onClick={reloadAction}>
                                    <RxReload className={`${reloading ? "rotate-load" : ""}`} />
                                </button>
                            </div>
                        </div>

                        <div className="bootstrapTable">
                            {loading && <div className="text-center p-5"><Defaultloadinggif /></div>}
                            {!loading && (
                                <BootstrapTable
                                    keyField="id"
                                    columns={columns}
                                    data={filteredData}
                                    pagination={pagination}
                                    selectRow={selectRow}
                                    noDataIndication={
                                        <div className="noRecord">
                                            <p>No Content Classifications Available!</p>
                                        </div>
                                    }
                                    hover
                                    headerClasses="custom-header"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ContentClassification;